export enum BadgeSize {
	sm = 'sm',
	md = 'md',
	lg = 'lg',
	xl = 'xl',
}

export enum BadgeColor {
	white = 'white',
	neutral = 'neutral',
	primary = 'primary',
	purple = 'purple',
	red = 'red',
	orange = 'orange',
	green = 'green',
	yellow = 'yellow',
	transparent = 'transparent',
	salesforce = 'salesforce',
}

export interface BadgeProps {
	icon?: string;
	stroke?: boolean;
	clickable?: boolean;
	label?: string | number;
	borderColor?: string;
	backgroundColor?: string;
	fontColor?: string;
	iconColorOverride?: string;
	size?: keyof typeof BadgeSize;
	color?: keyof typeof BadgeColor;
	iconColor?: keyof typeof BadgeColor;
	contentPadding?: string;
	contentGap?: string;
	labelPadding?: string;
	height?: string;
	minHeight?: string;
}
